import {
  UserAPIRawRequestBodyType,
  UserAPIRequestBodyType
} from '../../types/user/api-request-body';

export const UserAPIRequestBody = ({
  name,
  email,
  password,
  isActive
}: UserAPIRequestBodyType): UserAPIRawRequestBodyType => ({
  username: name,
  email,
  password,
  is_active: isActive
});

export const UserAPIRequestBodyPartial = ({
  name,
  email,
  password,
  isActive
}: Partial<UserAPIRequestBodyType>): Partial<UserAPIRawRequestBodyType> => ({
  username: name,
  email,
  password,
  is_active: isActive
});
